import { render, staticRenderFns } from "./QuickSetupPreviewSkeleton.vue?vue&type=template&id=061f8cd2&scoped=true"
import script from "./QuickSetupPreviewSkeleton.vue?vue&type=script&lang=js"
export * from "./QuickSetupPreviewSkeleton.vue?vue&type=script&lang=js"
import style0 from "./QuickSetupPreviewSkeleton.vue?vue&type=style&index=0&id=061f8cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f8cd2",
  null
  
)

export default component.exports